{
  "nav": {
    "home": "Начало",
    "about": "За Интермедия",
    "services": "Услуги",
    "clients": "Клиенти",
    "projects": "Проекти",
    "partnerships": "Партньорства",
    "partnership_entrepreneur": "Бизнес партньорство",
    "partnership_programmer": "Програмистко партньорство",
    "work_training": "Работа и обучение",
    "free_positions": "Свободни позиции",
    "training_program": "Програма за обучение и менторство",
    "self_learning": "Ресурси за самообучение",
    "contact": "Контакти"
  },
  "breadcrumbs": {
    "home": "Начало",
    "work_training": "Работа и обучение",
    "training_program": "Програма за обучение и менторство",
    "self_learning": "Ресурси за самообучение",
    "free_positions": "Свободни позиции",
    "partnerships": "Партньорства",
    "partnership_entrepreneur": "Бизнес партньорство",
    "partnership_programmer": "Програмистко партньорство",
    "contact": "Контакти",
    "services": "Услуги",
    "clients": "Клиенти",
    "projects": "Проекти",
    "refunds": "Политика за връщане на средства",
    "delivery": "Политика за доставка"
  },
  "home": {
    "title": "За Интермедия",
    "intro_text": "Разработваме цялостни уеб решения (уеб сайтове, уеб приложения и мобилни приложения) от {companyYear} години. Офисът и екипът ни се намират в гр. Русе.",
    "partnership_entrepreneur_title": "Имам капитал и идея, търся екип",
    "partnership_programmer_title": "Работя по свой проект, търся финансиране",
    "services_intro": "Предлагаме следните услуги:",
    "service_project_management": "Управление на проекти по Agile методология (Scrum и Kanban)",
    "service_development": "Разработка на приложения (проектиране, дизайн и изработка на уеб сайт, разработка на уеб приложение и мобилно приложение)",
    "more_about": "Още за Интермедия",
    "we_work_with": "Работим с:",
    "tech_stack": "Laravel · Symfony · Ionic · ReactJS · AI Coding · AWS · Linode",
    "team_title": "Екип",
    "partnerships_title": "Партньорства",
    "partnerships_intro": "Инвестираме в добри идеи. Работим на джойнт венчър принцип както с предприемачи, които търсят екип за разработка на тяхна идея, така и с програмисти, които не разполагат с нужните ресурси за комерсиализиране на своите продукти.",
    "partnerships_choose": "Ако искате да обсъдим съвместно начинание, изберете линка, който по-точно описва вашата ситуация:",
    "entrepreneur_button_line1": "Имам капитал и идея,",
    "entrepreneur_button_line2": "търся екип",
    "programmer_button_line1": "Имам проект,",
    "programmer_button_line2": "търся финансиране",
    "programmer_button_long": "Работя по свой проект, търся финансиране",
    "our_projects": "Наши проекти",
    "more_projects": "Още за нашите проекти",
    "work_training_title": "Работа и обучение",
    "training_intro": "Обучаваме и предлагаме менторство на начинаещи уеб разработчици. Програмата ни за развитие обхваща следните теми:",
    "training_programming_basics": "Основи на програмирането и алгоритми",
    "training_oop": "Обектно-ориентирано програмиране",
    "training_clean_code": "Писане на чист програмен код",
    "training_php_laravel": "PHP и Laravel",
    "training_databases": "Бази данни",
    "training_tools": "Инструменти за професионална разработка",
    "more_training": "Още за работа и обучение в Интермедия",
    "free_positions_title": "Свободни позиции",
    "position_laravel": "PHP програмист: Laravel",
    "position_symfony": "PHP програмист: Symfony"
  },
  "team": {
    "member_0_first": "Красимир",
    "member_0_full": "Красимир Христозов",
    "member_1_first": "Николай",
    "member_1_full": "Николай Дацов",
    "member_2_first": "Пламен",
    "member_2_full": "Пламен Вълчиновски",
    "member_3_first": "Ангел",
    "member_3_full": "Ангел Драганов",
    "member_4_first": "Димитър",
    "member_4_full": "Димитър Рекинов",
    "member_5_first": "Милен",
    "member_5_full": "Милен Генов",
    "member_6_first": "Симона",
    "member_6_full": "Симона Илчева",
    "member_7_first": "Иво",
    "member_7_full": "Иво Владимиров",
    "member_8_first": "Салих",
    "member_8_full": "Салих Реджеб",
    "member_9_first": "Виктор",
    "member_9_full": "Виктор Великов"
  },
  "services": {
    "title": "Услуги",
    "business_analysis": "Бизнес анализ",
    "ba_intro": "Всеки нов проект в Интермедия започва с анализ на изискванията и провеждане на серия от разговори с клиента, за да се отговори на следните въпроси:",
    "ba_question_1": "Какви са изискванията на клиента и какви всъщност са нуждите му?",
    "ba_question_2": "Как работи бизнеса в момента и какви проблеми решава проекта?",
    "ba_question_3": "Каква е бизнес стойността на проекта?",
    "ba_question_4": "Може ли проектът да не се прави изобщо, а проблемите да се решат с използване на съществуващите системи на клиента или на готови системи от външни доставчици?",
    "ba_conclusion": "След изготвяне на ясна оценка на стойността, която ще донесе проекта, пристъпваме към дизайн на минималната възможна версия на продукта, която ще донесе полза на клиента, и започваме разработка по Agile методология.",
    "project_management": "Управление на проекти",
    "pm_philosophy": "Нашата философия при управление на проекти се състои от три основни принципа:",
    "pm_principle_1_title": "Партньори, а не изпълнители",
    "pm_principle_1_text": "Не работим според изпратени от клиента изисквания и спецификации, а се стремим да разберем изцяло бизнеса на клиента, за да предложим прагматично решение на всеки проблем.",
    "pm_principle_2_title": "Винаги създавай стойност",
    "pm_principle_2_text": "Всяка следваща версия на продукта, както и всяка промяна или нова функционалност, трябва да носи очевидна и измерима стойност за клиента.",
    "pm_principle_3_title": "Прозрачност в отношенията",
    "pm_principle_3_text": "Даваме достъп на клиента до системата ни за управление на проекти и поддържаме постоянна връзка, така че винаги можем да дадем отговор на следните въпроси:",
    "pm_principle_3_question_1": "По какви задачи се работи в момента?",
    "pm_principle_3_question_2": "Кой работи по всяка задача и какъв е срокът за изпълнение?",
    "pm_principle_3_question_3": "Какво е планираното и реално използвано време за всяка задача?",
    "pm_conclusion": "Използваме Agile методология (Scrum или Kanban, според нуждите на проекта) и Lean Startup принципите - кратки итерации до пускането на нови версии (работим със седмични спринтове), бърза валидация на промените и незабавно започване на следваща итерация.",
    "development": "Разработка на приложения",
    "dev_intro": "В Интермедия не правим просто уеб сайтове и не се занимаваме с дигитален маркетинг (оставили сме тази задача на ескпертите в тази област). Ние създаваме уеб приложения и мобилни приложения, които решават реални бизнес проблеми и носят стойност за нашите клиенти, като използваме най-добрите практики при съвременната разработка на софтуер.",
    "dev_agile": "Използването на Agile методология ни позволява да се адаптираме бързо към промени в изискванията и да създаваме решения, които могат да бъдат тествани и внедрени в работата при минимални срокове, след което да бъдат обновявани и поддържани.",
    "dev_cloud": "Предлагаме не само разработка на софтуер, но и изграждане и поддръжка на облачна сървърна архитектура (работим основно с AWS и Linode)."
  },
  "clients": {
    "title": "Клиенти",
    "oncallcentral_description": "SaaS продукт за улесняване на комуникацията между пациенти и лекарски практики в САЩ. Предлага възможност за динамично създаване на телефонни менюта, както и поддръжка на различни отдели и графици за телефонните менюта. Поддържа график на дежурствата с автоматични уведомления до дежурните лекари според предварително създадена схема. Записва всички проведени разговори, пълната история на всяко обаждане и свързаните с него уведомления. Продуктът се разработва и поддържа от нас от самото му създаване.",
    "pps_description": "За PPS създадохме серия от десктоп продукти за управление на портфолио от недвижими имоти, с множество награди за най-добър продукт в индустрията. Тези продукти са в основата на нашия проект Landlord Vision.",
    "taxinsider_description": "Tax Insider е изключително популярно месечно издание, предназначено за предприемачи, инвеститори и работещи на свободна практика във Великобритания. Изданието предлага полезни практически съвети за намаляване на данъчното облагане и оптимизиране на приходите и разходите.",
    "globelaw_description": "Globe Law and Business е издателство за специализирана литература по данъчни и бизнес теми във Великобритания. За тях разработихме система за управление на съдържанието и сайт за електронна търговия.",
    "rentgen_description": "За Рентген Русе на клиника Дукови разработихме уеб-базирано приложение за управление на снимките на пациенти с възможност за бързо споделяне на необходимата информация между пациенти, рентген и лекуващи зъболекари."
  },
  "projects": {
    "title": "Наши проекти",
    "lv_intro": "SaaS продукт за управление на портфолио от недвижими имоти, за пазара във Великобритания. Включва всички необходими инструменти, за да могат собствениците на недвижими имоти за отдаване под наем да управляват бизнеса си:",
    "lv_feature_1": "Пълна, вградена счетоводна система;",
    "lv_feature_2": "Управление на портфолиото и имотите;",
    "lv_feature_3": "Модул за управление на наематели, включително със система за осигуряване на поддръжка (базирана на нашия продукт Айкидеск);",
    "lv_feature_4": "Финансов модул;",
    "lv_feature_5": "Модул за работа с доставчици;",
    "lv_feature_6": "Генериране на пълен набор от документи, според изискванията на законодателството;",
    "lv_feature_7": "Интегриран календар с известия за събития и ранни предупреждения;",
    "lv_feature_8": "Отчети, включително счетоводни, съобразени с данъчното законодателство;",
    "lv_feature_9": "Възможност за автоматично събиране на наемите чрез интеграция с GoCardless;",
    "lv_feature_10": "Мобилни приложения за Android и iOS.",
    "landlord_vision_title": "Landlord Vision",
    "landlord_vision_description": "Системата се използва от над 4000 потребители, които управляват над 20000 активни договора за наем. Това е единствената система, която се препоръчва от най-голямата асоциация на наемодателите във Великобритания - NRLA.",
    "aikidesk_title": "Айкидеск",
    "aikidesk_intro": "Уеб-базирана система за обслужване на клиенти. Това е комерсиалната версия на наш продукт за собствена употреба, който се използва успешно в компании като Суперхостинг (с десетки хиляди клиенти). Основните предимства на нашата система са:",
    "aikidesk_feature_1": "Пълна локализация за българския пазар;",
    "aikidesk_feature_2": "Автоматична обработка на заявки и отговори по имейл, автоматично създаване на пощенски кутии за отделите;",
    "aikidesk_feature_3": "Имейл шаблони, които могат да се редактират;",
    "aikidesk_feature_4": "История на събитията за всяка заявка;",
    "aikidesk_feature_5": "Вътрешни съобщения и динамични уведомления по време на работа, за да се избегне едновременна работа на двама оператори по една и съща заявка, или пропускане на съобщение от потребителя по време на писане на отговор."
  },
  "job": {
    "free_positions_title": "Свободни позиции",
    "application_form_title": "Форма за кандидатстване",
    "position": "Позиция",
    "position_laravel_full": "PHP програмист - Laravel",
    "position_symfony_full": "PHP програмист - Symfony",
    "position_2_requirements": "- Отлични познания по основи на програмирането - разработка и анализ на алгоритми<br>- Отлични познания по обектноориентирано програмиране<br>- Опит в проектирането на релационни бази данни<br>- PHP/MySQL<br>- Опит с MVC-базиран PHP Framework (използваме предимно Laravel, предлагаме възможност за обучение)<br>- Владеене на английски език (писмено - работно ниво)<br>- Git",
    "position_2_advantages": "- Познания по HTML5 и CSS3<br>- Опит с JavaScript framework (Vue.js, React.js или Angular)<br>- Опит с AI инструменти за разработка (Claude Code, GitHub Copilot)",
    "position_2_qualities": "- Отлична комуникативност<br>- Добра организираност и самодисциплина<br>- Желание за усъвършенстване на уменията и професионално израстване",
    "position_2_note": "Работата е само на място в офиса на фирмата. Предлагаме възможност за обучение и работа по интересни SaaS проекти. Позицията е подходяща за студенти.",
    "position_1_requirements": "- Отлични познания по основи на програмирането - разработка и анализ на алгоритми<br>- Отлични познания по обектноориентирано програмиране<br>- PHP, опит със Symfony framework (предлагаме възможност за обучение)<br>- PostgreSQL<br>- Владеене на английски език (писмено - работно ниво)<br>- Git",
    "position_1_advantages": "- Опит с AI инструменти за разработка (Claude Code, GitHub Copilot)",
    "position_1_qualities": "- Отлична комуникативност<br>- Добра организираност и самодисциплина<br>- Желание за усъвършенстване на уменията и професионално израстване",
    "position_1_note": "Работата е само на място в офиса на фирмата. Позицията е подходяща за студенти.",
    "requirements_title": "Изисквания:",
    "advantages_title": "Предимства:",
    "qualities_title": "Държим на следните личностни качества:",
    "direction": "Направление",
    "name": "Име",
    "name_placeholder": "Име и фамилия",
    "email": "Имейл",
    "phone": "Телефон",
    "why_apply": "Защо кандидатствате при нас",
    "expectations": "Какво очаквате от тази програма",
    "cv_formats": "CV позволени формати: pdf, ods",
    "submit_cv": "Пусни CV",
    "send": "Изпрати"
  },
  "training": {
    "intro": "Програмата ни за обучение и менторство е напълно безплатна и е предназначена основно (но не само) за студенти в областта на информационните технологии и компютърните науки. Програмата започва с оценка на началното ниво (чрез провеждане на интервю) и създаване на индивидуална програма за самообучение и работа по собствен проект, с цел придобиване на необходимите знания за започване на работа като уеб разработчик. Осигуряваме обратна връзка и преглед на кода, както и допълнителни насоки по време на самообучението. Разчитаме основно на личната мотивация на всеки кандидат и приемаме само малка част от кандидатите в нашата програма.",
    "areas_intro": "Програмата обхваща следните области на професионална компетентност:",
    "general": "Общи:",
    "topic_programming_basics": "Основи на програмирането;",
    "topic_algorithms": "Алгоритми и структури от данни;",
    "topic_algorithm_analysis": "Анализ на алгоритми;",
    "topic_oop": "Обектно-ориентирано програмиране и дизайн (SOLID/DRY принципи, design patterns);",
    "topic_clean_code": "Писане на чист програмен код;",
    "topic_testing": "Тестване на кода, TDD/BDD;",
    "topic_refactoring": "Рефакторинг, работа със съществуващ код;",
    "topic_functional": "Функционално програмиране;",
    "topic_tools": "Инструменти (git, WSL2, docker);",
    "topic_ai_coding_tools": "AI инструменти за разработка (Claude Code, GitHub Copilot, prompt engineering);",
    "topic_agile": "Agile методология (Scrum, Kanban) и инструменти за съвместна работа (Zoho Projects, Trello, Asana, Slack);",
    "topic_estimation": "Техники за оценка на времето за разработка;",
    "topic_communication": "Професионална комуникация;",
    "topic_cv_presentation": "Подготовка на CV и презентационни умения за представяне на личните проекти.",
    "backend": "За backend разработчици:",
    "topic_databases": "Бази данни (SQL);",
    "topic_devops": "DevOps (Linux администрация - Ubuntu/CentOS/Amazon Linux, доставчици на cloud услуги - AWS, Linode, DigitalOcean, shell програмиране)",
    "topic_php": "PHP;",
    "topic_laravel": "Laravel;",
    "topic_dev_environments": "Среди за разработка;",
    "topic_other_language": "Друг език за програмиране по желание на кандидата - Python, Ruby (+Rails).",
    "frontend": "За frontend разработчици:",
    "topic_javascript": "JavaScript, ECMAScript, TypeScript;",
    "topic_html_css": "HTML/CSS/Bootstrap/Flexbox;",
    "topic_vuejs": "React/Angular;",
    "topic_state_management": "Vuex/Redux;",
    "topic_frontend_tools": "Инструменти (npm, yarn, webpack);"
  },
  "contact": {
    "title": "Свържи се с нас",
    "name": "Име",
    "name_placeholder": "Име и фамилия",
    "email": "Имейл",
    "message": "Съобщение",
    "send": "Изпрати",
    "contact_info": "Информация за контакт",
    "phone": "Телефон",
    "address": "Адрес",
    "company_name": "Интермедия ООД",
    "company_street": "ул. Николай Здравков 4",
    "company_city": "Русе 7012",
    "map_email": "Имейл",
    "map_phone": "Телефон",
    "map_address": "Адрес"
  },
  "partnership": {
    "name": "Име",
    "name_placeholder": "Име и фамилия",
    "email": "Имейл",
    "phone": "Телефон",
    "project_description": "Описание на проекта",
    "attach_files": "Прикачете материали",
    "allowed_formats": "позволени формати: pdf, ods, zip",
    "development_platform": "Платформа за разработка",
    "git_link": "GitHub/BitBucket линк",
    "send": "Изпрати"
  },
  "resources": {
    "title": "Ресурси за самообучение",
    "filter": "Филтър",
    "results": "Намерени {count} резултата",
    "tags": "Тагове",
    "no_results": "Няма намерени резултати"
  },
  "footer": {
    "copyright": "© {year} Интермедия. Всички права запазени.",
    "refunds_policy": "Политика за връщане на средства",
    "delivery_policy": "Политика за доставка"
  },
  "messages": {
    "invalid_email": "Невалиден имейл адрес",
    "invalid_git_link": "Невалиден GitHub/BitBucket линк",
    "required": "Полето :attribute е задължително",
    "recaptcha": "\"I'm not a robot\" е задължително",
    "success": "Успешно изпратено",
    "error": "Възникна грешка",
    "loading": "Зареждане...",
    "contact_us_sent": "Съобщението беше изпратено успешно",
    "job_app_sent": "Кандидатурата беше изпратена успешно"
  },
  "validation": {
    "email": "Полето :attribute е в невалиден формат",
    "min": "Полето :attribute трябва да бъде знаков низ с дължина минимум :min знака",
    "max": "Полето :attribute трябва да бъде знаков низ с дължина максимум :max знака",
    "string": "Полето :attribute трябва да бъде знаков низ",
    "required": "Полето :attribute е задължително",
    "file": "Невалиден файл",
    "file_name": "Невалиден файл: :name"
  },
  "common": {
    "menu_title": "Съдържание",
    "select_option": "- Изберете -",
    "choose_file": "Choose file",
    "read_more": "Прочети повече",
    "back": "Назад",
    "next": "Напред",
    "close": "Затвори",
    "submit": "Изпрати",
    "cancel": "Откажи",
    "save": "Запази",
    "delete": "Изтрий",
    "edit": "Редактирай",
    "search": "Търси",
    "filter": "Филтрирай",
    "all": "Всички",
    "yes": "Да",
    "no": "Не"
  }
}
